import "./Contact.module.css";
import CabecalhoInstitucional from "@/reusable_sections/Header";
import TalkToEngineering from "./sections/TalkToEngineering";
import SolicitacaoDeProposta from "./sections/SolicitacaoDeProposta";
import InformativeFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <CabecalhoInstitucional />
      <TalkToEngineering />
      <SolicitacaoDeProposta />
      <InformativeFooter />
    </div>;
}